var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.625,
    height: 17,
    viewBox: "0 0 10.625 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1310.084,4985.813h-9.563a.531.531,0,0,0-.531.532v10.625a.531.531,0,0,0,.136.355l4.781,5.312a.53.53,0,0,0,.4.176.528.528,0,0,0,.4-.176l4.781-5.312a.532.532,0,0,0,.137-.355v-10.625A.531.531,0,0,0-1310.084,4985.813Z",
    transform: "translate(1320.178 -4985.813)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbWhite);
export default __webpack_public_path__ + "static/media/thumb-white.713dbdfd2544c3e299a0b92830765db2.svg";
export { ForwardRef as ReactComponent };